import React from 'react';
import PropTypes from 'prop-types';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import './Pill.scss';

const Pill = ({ className, tagName: Tag, theme, hasError, disabled, active, ...props }) => {
  const classes = withMods('pill', `pill--theme-${theme}`, { hasError, disabled, active }, className);

  return <Tag {...props} className={classes} disabled={disabled} />;
};

Pill.defaultProps = {
  tagName: 'div',
};

Pill.propTypes = {
  className: PropTypes.string,
  tagName: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'warn', 'danger']),
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
};

export default Pill;
